import { render, staticRenderFns } from "./support-message-attachment.vue?vue&type=template&id=3f6f5dde&scoped=true&"
import script from "./support-message-attachment.vue?vue&type=script&lang=js&"
export * from "./support-message-attachment.vue?vue&type=script&lang=js&"
import style0 from "./support-message-attachment.vue?vue&type=style&index=0&id=3f6f5dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6f5dde",
  null
  
)

export default component.exports